{
  "no_pending_audit_evidence": "此阶段没有需要导入的待处理证据。",
  "audit_run_progress_unavailable": "无法加载分析进度，请重试。",
  "generic": "出错了。",
  "network": "网络错误。请检查您的连接后重试。",
  "unauthorized": "您无权执行此操作。",
  "forbidden": "拒绝访问。",
  "notFound": "未找到。",
  "serverError": "服务器错误。请稍后重试。",
  "timeout": "请求超时。",
  "validation": "请检查标红字段。",
  "required": "此项为必填项。",
  "invalidEmail": "请输入有效的邮箱地址。",
  "tooLong": "过长。",
  "tooShort": "过短。",
  "uploadFailed": "上传失败。",
  "deleteFailed": "删除失败。",
  "folderDeletePartial": "文件夹删除部分失败（{{failed}}/{{total}}）：{{error}}",
  "saveFailed": "保存失败。",
  "loadFailed": "无法加载。",
  "exportFailed": "导出失败。",
  "operationFailed": "操作失败。",
  "tryAgain": "重试",
  "dismiss": "关闭",
  "errorBoundary": {
    "title": "出错了",
    "body": "发生意外错误。请尝试刷新页面。",
    "componentLabel": "组件：{{name}}",
    "tryAgain": "重试"
  },
  "fallback": {
    "issueLog": "问题日志获取失败",
    "issueLogStalled": "问题日志的更新未能完成。请刷新页面再次查看。",
    "referenceList": "参考文献列表获取失败",
    "citation": "引用获取失败",
    "citationUnaddressable": "此引用没有可查询的来源引用。",
    "planLookup": "无法加载工作区计划，聚合恢复操作不可用。请刷新页面。",
    "severityTaxonomy": "严重程度分类法加载失败",
    "recentActivity": "近期动态不可用",
    "analyticsData": "分析数据加载失败",
    "workflowStates": "工作流分类法不可用",
    "fileRetry": "文件重试失败。请重试。",
    "unknown": "未知错误",
    "saveSection": "章节保存失败。请重试。",
    "saveSectionUnconfirmed": "您的修改已保存，但无法加载更新后的章节。请刷新页面以查看。",
    "retry": "无法重新生成该章节。请稍后再试。",
    "phase2cRefire": "执行摘要生成重新启动失败",
    "cancelTestRun": "取消测试运行失败。请重试。",
    "cancel": "取消失败。请重试。",
    "acceptGap": "无法将该章节接受为数据缺口。请重试。"
  },
  "sectionFailure": {
    "transient": "生成遇到暂时性服务问题。请稍候片刻，然后重试该章节。",
    "context": "Bennie 无法为该章节收集到足够的源文件上下文。请重试，或上传更多源文件。",
    "reviewNotPassed": "该章节的草稿未通过自动审查。请使用“重试”重新生成。",
    "reviewUnavailable": "该报告的自动审查未能完成。请使用“重试”重新运行。",
    "truncated": "模型的回复在完成前被截断。请重试该章节。",
    "outOfEvidence": "该章节试图引用不属于本报告证据的来源。请使用“重试”重新生成。",
    "execSummary": "执行摘要无法生成。请在正文章节完成后重试。",
    "incomplete": "该章节的生成未能完成。请使用“重试”重新运行。",
    "cancelled": "该章节的生成已取消。请使用“重试”重新运行。",
    "interrupted": "该章节的生成被中断。请使用“重试”重新运行。",
    "default": "该章节遇到意外问题。请使用“重试”重新运行。",
    "versionFailed": "此章节在报告版本完成前已停止。请生成新版本。",
    "newerVersionStopped": "此章节在较新的版本中未完成，该版本已停止。当前版本不受影响。"
  },
  "modelWriteDenied": {
    "model_archived": "该模型已归档。已归档的模型无法再修改。",
    "principal_oid_unresolved": "只有已登录的组织账户才能修改模型。",
    "no_access_row": "您没有该模型的编辑权限。对该模型的修改由其所有者或管理员进行；如需权限，请联系管理员将您添加到该模型。",
    "role_collaborator": "您是该模型的协作者。模型记录本身由其所有者或管理员修改；您自己的权限覆盖已交给您的工作。",
    "service_type_not_granted": "您是该模型的协作者，但此类工作不在交给您的权限范围内。该模型的所有者或管理员可以扩大您在该模型上的权限范围。",
    "service_type_not_entitled": "您的账户尚未获得此类工作的资格。只有管理员能开通，模型所有者无法开通。",
    "service_type_not_entitled_no_access_row": "在此开始此类工作还缺两项：该模型上的权限，以及您账户对此类工作的资格。管理员可以为您开通这两项。",
    "service_type_not_entitled_service_type_not_granted": "在此开始此类工作还缺两项：您在该模型上的权限未覆盖此类工作，以及您的账户尚未获得此类工作的资格。管理员可以为您开通这两项。",
    "workspace_not_model_rooted": "该项目未关联任何模型，因此无法确认您在此处可以修改的内容。未做任何更改。需要管理员处理。",
    "workspace_model_unresolvable": "无法读取该项目所属的模型，因此无法确认您可以修改的内容。未做任何更改。需要管理员处理。",
    "default": "当前无法修改该模型。"
  },
  "AUTH_REQUIRED": "请登录后继续。",
  "accept_as_is_failed": "按原样接受失败。请重试。",
  "applied_pairs_malformed": "无法读取文档类型选择中的下级选项，本次审查未启动。请清除文档类型后重新选择，然后重新运行。",
  "applied_pairs_vocab_menu_unavailable": "文档类型列表暂时不可用，无法确认您所选的下级选项，本次审查未启动。请稍后重试。",
  "applied_to_invalid": "本次运行的文档类型在所选垂直领域中已不是有效选项，本次审查未启动。请将其清除，从当前列表中重新选择文档类型，然后重新运行。",
  "applied_to_malformed": "无法读取文档类型的选择内容，本次审查未启动。请清除文档类型后重新选择，然后重新运行。",
  "applied_to_vocab_menu_unavailable": "文档类型列表暂时不可用，无法确认您的选择，本次审查未启动。请稍后重试。",
  "approval_in_progress": "该工作区已有计划批准正在进行中。",
  "auth_invalid_password": "访问密码缺失或无效。",
  "approve_failed": "章节批准失败。请重试。",
  "batch_generation_in_progress": "该工作区的章节生成仍在进行中。请等待完成后再重新生成单个章节。",
  "blob_missing": "所请求的文件在存储中缺失。",
  "blob_not_found": "未找到已上传的文件，上传可能未成功。",
  "blob_not_in_version": "所请求的文件不属于此运行版本。",
  "blob_path_mismatch": "blob 路径与预期的工作区/文件范围不一致。",
  "blob_url_invalid": "提供的 blob URL 对此操作无效。",
  "blob_url_required": "需要提供 blob URL。",
  "block_id_malformed": "block_id 格式无效（仅允许字母、数字、下划线、连字符，长度不超过 64 个字符）。",
  "block_not_found": "未找到所请求的区块。",
  "block_not_terminal": "该区块尚未达到终态。只有在区块成功、失败、跳过或取消之后，才可逐区块下载。",
  "both_runners_failed": "本次运行的内部审阅器与合规审阅器均已失败。",
  "bundle_corpus_empty": "捆绑包的语料库为空。可能是提取器尚未完成合成，或后处理已被禁用。",
  "bundle_corpus_missing": "捆绑包缺少必需的语料库内容。",
  "bundle_index_invalid": "捆绑包索引无效。",
  "bundle_index_missing": "此包由旧版本创建，缺少 index.json。请重新运行提取器。",
  "bundle_missing": "未找到所请求的捆绑包。",
  "tool_has_no_downloadable_artifact": "此工具不会生成可下载的文件。请改为将其结果发送到项目中。",
  "unsupported_download_format": "本次运行无法以该文件类型下载。请选择运行页面上显示的下载方式之一。",
  "workbook_unavailable_for_legacy_result": "本次运行早于评分检查，因此无法据此生成工作簿。请改为下载报告。",
  "catalog_read_failed": "由于暂时性错误未能检查该文件的状态。请重试。",
  "citation_not_found": "未找到所引用的引文。",
  "cohort_not_ready": "整体自检被阻止 — 一个或多个章节尚未达到终态。请重试失败的章节，或将其作为缺口接受，以便在带占位符的情况下导出报告。",
  "completeness_not_computed": "该计划的完备性尚未计算。请通过批准文件元数据来触发。",
  "invalid_completeness_scope": "无法识别该覆盖检查。请重新加载页面后重试。",
  "composer_failed": "编排器失败。请重试。",
  "concierge_classifier_cancelled": "分类器已被取消。",
  "corpus_too_large": "捆绑包语料库过大，无法在一次请求中处理。",
  "data_ingest_phase1_failed": "数据接入在准备您的文件时失败。请重试。",
  "delete_not_allowed": "该文件仍在处理中，暂时无法删除（当前：{{processing_status}}）。请等待处理完成后再重试。",
  "deletion_incomplete": "该文件仅被部分删除。系统已保留该文件，您可重试删除。",
  "description_save_failed": "描述保存失败。请重试。",
  "directory_unavailable": "无法访问贵组织的目录，因此未能查找该人员。尚未做出任何更改——请稍后重试。",
  "edit_base_version_required": "此次编辑未说明其基于哪个版本，因此无法保存。请重新打开该章节后再试。",
  "edit_base_version_stale": "您编辑期间该章节已发生变更，保存未生效。请重新打开该章节查看当前版本，然后重新应用您的修改。",
  "edit_concurrent_append": "他人在同一时刻保存了该章节，您的保存未生效。请重新打开该章节查看当前版本，然后重新应用您的修改。",
  "edit_status_sync_failed": "编辑已保存为新版本，但状态同步失败。",
  "empty_file": "文件「{{filename}}」为空。",
  "enumerate_unenriched_images_failed": "枚举未补全的图片时出错。请重试。",
  "ECHARTS_BLOCK_INVALID": "本节的图表未能通过校验，已保留您之前的版本。请重试。",
  "evidence_map_failed": "构建证据映射时失败。请重试。",
  "evidence_map_scope_invalid": "请选择报告、设计或运行的证据视图。",
  "file_delete_failed": "删除文件失败。请重试。",
  "file_list_failed": "由于暂时性错误未能列出文件。请重试。",
  "enabled_categories_parse_failed": "enabled_categories 字段解析失败。",
  "enrichment_gate_unavailable": "源文件处理暂时不可用。请稍后重试。",
  "enrichment_in_progress": "该工作区已有数据补全任务正在进行中。",
  "enrichment_not_allowed": "在工作区的当前阶段无法处理源文件。",
  "enrichment_not_allowed_before_plan": "计划获批后即可处理源文件。",
  "enrichment_not_allowed_generating": "报告生成期间，源文件处理已暂停。",
  "enrichment_not_allowed_finalizing": "工作区正在完成报告，暂时无法处理源文件。",
  "enrichment_not_allowed_complete": "报告已完成，无法再处理源文件。",
  "enrichment_not_allowed_archived": "该工作区已归档，无法再处理源文件。",
  "enrichment_not_allowed_model_archived": "该工作区所属的模型已归档，无法再处理源文件。",
  "es_sections_not_found": "在 sections 容器中未找到执行摘要章节记录。",
  "excel_not_supported": "Excel 工作簿不适合上下文扫描。请先使用模型提取器工具生成结构化的捆绑包。",
  "export_admonition_token": "导出已阻止：“{{section}}”中有一个标注标记位于句子内部，无法在此位置渲染。请重新生成该章节后再次导出。",
  "export_bracket_drift": "导出已阻止：“{{section}}”中包含报告格式无法渲染的方括号引用标记。请重新生成该章节后再次导出。",
  "export_bracket_drift_document": "导出已阻止：报告中包含报告格式无法渲染的方括号引用标记。请重新生成受影响的章节后再次导出。",
  "export_chart_render_failed": "导出已阻止：“{{section}}”中的图表无法绘制。请重新生成该章节后再次导出。",
  "export_dollar_math": "导出已阻止：“{{section}}”中的公式使用了报告格式不接受的分隔符。请重新生成该章节后再次导出。",
  "export_failed": "导出失败。请重试。",
  "section_version_id_required": "请为要导出的章节选择一个版本，然后重试。",
  "section_version_id_invalid": "所选版本无效。请从列表中选择一个版本，然后重试。",
  "section_version_not_found": "找不到所选版本。请刷新页面，从列表中选择一个版本，然后重试。",
  "report_version_id_required": "请选择要导出的报告版本，然后重试。",
  "report_version_not_found": "找不到该报告版本。请选择其他版本，然后重试。",
  "report_version_not_exportable": "该报告版本目前无法导出。请选择已完成的版本，然后重试。",
  "report_version_unrenderable": "该版本已无法重新生成以供导出，因为其部分内容已不存在。请选择其他版本。",
  "export_selection_conflict": "请选择报告版本或各章节版本之一进行导出，不能同时选择。",
  "section_id_required": "请选择要导出的章节，然后重试。",
  "export_file_not_found": "未找到导出文件。",
  "export_placeholder_unconsumed": "导出已阻止：报告模板中没有“{{section}}”对应的占位区，其内容将被悄然遗漏。请在模板中为其添加占位区，或删除该章节，然后再次导出。",
  "export_section_too_large": "导出已阻止：“{{section}}”内容过长，无法渲染。请精简该章节或将其拆分为更短的章节，然后再次导出。",
  "export_too_large": "导出已阻止：报告内容过长，无法渲染。请精简或删除部分章节，然后再次导出。",
  "export_issue_token_unresolved": "导出已阻止：以下章节包含报告无法关联的问题引用：{{sections}}。请对这些章节分别使用“反馈”重新生成，然后再次导出。",
  "export_cover_substitution_failed": "导出未能完成：无法填写报告封面信息。请重新尝试导出。",
  "export_record_write_failed": "导出未能完成：报告记录未能保存，因此文件未提供下载。请重新尝试导出。",
  "export_reference_list_missing": "导出已阻止：报告的参考文献列表尚未就绪。请稍候片刻，然后再次尝试导出。",
  "export_in_progress": "该工作区已有导出任务正在进行中。请等待其完成。",
  "feedback_in_progress": "该工作区已有计划反馈正在处理。请稍候。",
  "file_missing": "缺少所需的文件。",
  "file_not_failed": "只有状态为「extraction_failed」或「indexing_failed」的文件才可重试。",
  "file_not_found": "未找到所请求的文件。",
  "file_too_large": "文件「{{filename}}」过大（最大 {{max_bytes}} 字节）。",
  "filename_invalid": "文件名无效（不得包含路径分隔符）。",
  "filename_required": "需要提供文件名。",
  "files_missing": "未提供任何文件。",
  "gate_refused": "自检关卡未触发。请确认所有正文章节均已自检且工作流未被取消。",
  "gd_available_invariant_violation": "通用任务（Generic Task）不提供精选知识。请选择其他服务类型，或不要启用精选知识。",
  "generation_in_progress": "该工作区已有章节生成任务正在进行中。请等待其完成。",
  "section_needs_regeneration_for_version": "部分章节需要重新生成后才能通过验证。请重新生成后重试。",
  "holistic_revalidation_failed": "整体重新自检失败。请重试。",
  "import_gate_unavailable": "目前无法导出到工作区。请稍后重试。",
  "import_landed_no_rows": "导出内容中没有可用文件，因此未向此工作区添加任何内容。",
  "import_not_allowed": "在工作区的当前阶段无法导入工具箱捆绑包。",
  "import_not_allowed_before_plan": "计划获批后即可导入工具箱捆绑包。",
  "import_not_allowed_generating": "报告生成期间，工具箱捆绑包导入已暂停。",
  "import_not_allowed_finalizing": "工作区正在完成报告，暂时无法导入工具箱捆绑包。",
  "import_not_allowed_complete": "报告已完成，无法再导入工具箱捆绑包。",
  "import_not_allowed_archived": "该工作区已归档，无法再导入工具箱捆绑包。",
  "import_not_allowed_model_archived": "该工作区所属的模型已归档，无法再导入工具箱捆绑包。",
  "file_already_uploaded": "该文件（「{{file_name}}」）已上传到此工作区。",
  "upload_finalize_in_progress": "此文件仍在登记中。请稍候，然后刷新以确认是否已添加。",
  "upload_transfer_changed": "此上传已无法完成。请在同一标签页中重新添加该文件。",
  "upload_admission_busy": "工作区正忙，无法开始上传。请稍后重新添加该文件。",
  "upload_blob_properties_not_allowed": "此文件上传时使用了我们无法接受的存储设置。请从此页面重新上传。",
  "file_already_parked": "该文件（「{{file_name}}」）已保存在此工作区中。",
  "ineligible_status": "该章节状态不适用于所请求的操作。",
  "infrastructure_halt": "由于上游 LLM 服务商出现问题，章节生成已暂停。请点击「清除暂停并重试」以恢复。",
  "ingest_in_progress": "该工作区已有数据接入任务正在进行中。请等待其完成后再重新开始。",
  "ingest_in_progress_collection": "此工作区正在添加新的证据。请先完成上传、审阅和导入，然后重试。如果上传被中断，请在覆盖面板中使用“重新检查”。",
  "ingest_incomplete": "无法生成章节——数据接入尚不完整。请先重新接入源数据，然后再生成报告。",
  "enrichment_incomplete": "无法生成章节——元数据丰富化未完成。请先对源文件重新运行元数据丰富化，然后再生成报告。",
  "intent_invalid": "重新生成意图「{{explicitIntent}}」无效。有效值：retry_after_failure、bulk_retry、holistic_flagged、user_feedback。",
  "intent_required": "必须明确提供重新生成意图。有效值：retry_after_failure、bulk_retry、holistic_flagged、user_feedback。",
  "internal_unexpected_error": "发生意外错误。请重试。",
  "invalid_metadata_fields": "此次编辑包含不可编辑的字段。",
  "invalid_selections": "一个或多个章节选择无效。",
  "invalid_state": "该章节当前状态不适用于此操作。",
  "invalid_transition": "在工作区的当前阶段无法执行此操作。请等待当前步骤完成后再重试。",
  "issue_log_not_ready": "问题日志将在报告自检完成后可导出。",
  "job_already_terminal": "该任务已达到终态。",
  "job_id_required": "需要提供 job_id。",
  "job_not_found": "未找到任务。",
  "job_not_succeeded": "该任务不处于成功状态。",
  "job_outputs_malformed": "无法读取本次运行已保存的结果，因此未导出任何内容。请重新运行审查。",
  "code_walkthrough_export_too_large": "此代码走查内容过大，无法导出到工作区。请改为下载工作簿，或减少文件后重新运行。",
  "job_not_terminal": "该任务尚未达到终态。请在删除前先取消。",
  "job_terminal": "该任务已达到终态。",
  "no_inflight_toolbox_job": "此实例上没有正在运行的工具箱任务。",
  "shutdown_already_requested": "此实例已在关闭中。",
  "replica_shutting_down": "该服务正在重启，请稍后重试。",
  "job_terminal_or_missing": "该任务已终止或不再存在。",
  "metadata_edit_failed": "元数据编辑保存失败。",
  "metadata_preparation_failed": "无法开始数据导入。请重试。",
  "metadata_preparation_unavailable": "数据导入暂时不可用。请稍后重试。",
  "completeness_preparation_unavailable": "此操作暂时不可用。请稍后重试。",
  "metadata_preparation_changed": "数据导入开始前，工作区已发生更改。请刷新后重试。",
  "metadata_preparation_busy": "文件仍在添加到此工作区。请等待上传完成后重试。",
  "ingest_state_not_restartable": "当前工作区所处的步骤无法重新开始数据导入。请等待当前步骤完成后重试。",
  "missing_field": "缺少必填字段。",
  "missing_filename": "fileName 为必填项。",
  "missing_resolver": "请提供 workspace_id 或 service_type。",
  "missing_service_type": "service_selection.service_type 为必填项。",
  "missing_workspace_id": "workspace_id 参数为必填项。",
  "no_active_generation": "该工作区当前没有正在进行的生成任务。",
  "no_active_turn": "当前没有可停止的回答。",
  "turn_not_current": "该回答不是当前正在进行的回答。",
  "not_stoppable_in_this_phase": "此回答已无法停止。",
  "invalid_turn_ordinal": "回答标识无效。",
  "no_check_produced_a_result": "本次运行没有任何检查完成，因此没有可导出的内容。请重新运行审查。",
  "no_exec_summary": "该计划未包含 category=executive_summary 标签的章节。请修改计划，使执行摘要根节点带有该分类。",
  "no_exportable_content": "无法导出：没有任何章节已生成内容。请先生成至少一个章节。",
  "no_failed_exec_summary": "没有处于可重试状态的执行摘要章节。",
  "no_reggie_eligible_functions": "该范围下没有任何精选知识清单声明 dataframe_io — 工具面板将为空。",
  "no_sections": "无可导出的章节。请先生成章节。",
  "no_source_data": "没有可处理的源文件。请至少上传一个源文件，然后重试。",
  "no_source_files": "未提供任何源文件。",
  "no_validated_content": "导出需要至少一个章节达到终态。请先对至少一个章节执行整体自检、按原样接受或作为缺口接受。",
  "not_halted": "该工作区不处于基础设施暂停状态。",
  "only_enabled_runner_failed": "本次运行中唯一启用的审阅器已失败，没有可导出的内容。",
  "options_invalid_value": "字段「{{field}}」的选项值无效。",
  "options_parse_failed": "选项负载解析失败。",
  "outputs_missing": "未找到预期的输出。",
  "package_too_large": "提交包过大。",
  "park_failed": "未能将该文件保存到此工作区。请重试。",
  "mdr_preload_failed": "项目已创建，但未能添加其模型开发报告。请重试。",
  "park_gate_unavailable": "工作区暂时不可用。请稍后重试。",
  "park_not_allowed": "在工作区的当前阶段无法保存该文件。",
  "park_not_allowed_generating": "报告生成期间无法保存文件。",
  "park_not_allowed_finalizing": "工作区正在完成报告，暂时无法保存文件。",
  "park_not_allowed_complete": "报告已完成，无法再保存文件。",
  "park_not_allowed_archived": "该工作区已归档，无法再保存文件。",
  "park_not_allowed_model_archived": "该工作区所属的模型已归档，无法再保存文件。",
  "path_invalid": "路径无效。",
  "path_required": "需要提供路径。",
  "phase2c_refire_failed": "Phase 2C 重新触发失败。请重试。",
  "pipeline_config_yaml_input_patch_failed": "对输入 pipeline_config_yaml 的补丁应用失败。",
  "pipeline_config_yaml_invalid": "pipeline_config_yaml 无效。",
  "pipeline_config_yaml_invalid_after_patch": "应用补丁后 pipeline_config_yaml 无效。",
  "pipeline_config_yaml_required": "pipeline_config_yaml 为必填项。",
  "pipeline_empty": "流水线为空。",
  "pipeline_in_flight": "在章节仍在生成、自检或聚合时，导出将被阻止。请等待流水线稳定。",
  "plan_already_exists": "该工作区已存在计划。",
  "plan_id_required": "请以查询参数 ?planId=<plan_id> 提供。",
  "plan_malformed": "计划文档缺少 items/sections 数组。",
  "plan_not_found": "未找到计划。",
  "plan_not_stable": "章节生成需要已批准的计划。",
  "plan_parse_failed": "计划响应解析失败。",
  "plan_read_failed": "计划读取失败。",
  "plan_state_inconsistent": "无法加载您的计划。请刷新页面；如果问题仍然存在，请重新生成计划。",
  "plan_version_not_found": "未找到计划版本。",
  "prompt_set_unavailable": "提示词集不可用。",
  "reason_required": "需要提供非空的原因。",
  "reference_not_a_section": "参考文献列表根据报告自动生成，无法单独重新生成。",
  "regen_in_progress": "该章节正在重新生成中。请稍候。",
  "regen_stream_interrupted": "重新生成该章节时连接中断。该章节已恢复到此前的状态，请重试。",
  "reggie_flat_folder_path": "某个文件夹布局条目存在非预期的扁平路径。",
  "reggie_folder_entry_no_blob": "某个文件夹布局条目缺少其 blob URL。",
  "reggie_outputs_empty": "此次运行既没有文件夹布局，也没有最终输出 — 没有可导入的内容。",
  "render_empty": "DOCX 渲染生成的文件为空。",
  "export_asset_ownership_refused": "导出已阻止：无法确认某张图片或图表属于此工作区。请重试导出。若问题持续，请重新生成相关内容后再导出。",
  "render_failed": "DOCX 渲染失败。",
  "retry_generation_failed": "重试生成失败。请重试。",
  "retry_validation_failed": "重试自检失败。请重试。",
  "run_record_id_collision": "运行记录 ID 冲突。",
  "run_record_id_required": "需要提供 run_record_id。",
  "run_record_not_found": "未找到运行记录。",
  "scope_path_required": "需要提供 scope_path。",
  "scope_path_not_offered": "该领域不在您的服务菜单中提供，因此未在其中创建任何内容。请选择其他领域，或联系管理员。",
  "scope_incomplete": "文档类型选择不完整。请选择完整的文档类型，或将其清除以在不进行合规检查的情况下运行。",
  "search_unavailable": "搜索功能暂时不可用。",
  "section_generation_in_flight": "部分章节仍在生成中。此时下载只会得到它们的旧内容，因此在生成完成前无法下载报告。",
  "section_not_found": "未找到章节 {{section_id}}。",
  "service_type_config_not_found": "在精选知识中未找到该服务类型的 finding-config 或 block-titles。",
  "service_unavailable": "所需的后端服务暂不可用。请稍后重试。",
  "service_type_has_no_findings": "该工作区的服务类型不会产生发现项。",
  "service_type_missing": "该工作区未设置 service_type。",
  "service_type_required": "service_type（文档类型）为必填项。",
  "severity_levels_not_found": "已解析的服务类型没有 severity_levels 列表。",
  "size_bytes_required": "size_bytes 为必填项。",
  "snapshot_not_ready": "分析快照「{{snapshot_type}}」正在初始化。请稍后重试。",
  "source_file_missing": "缺少一个源文件。",
  "submission_files_empty": "提交内容不包含任何源文件。",
  "submission_files_missing": "提交未设置任何源文件。",
  "submission_no_usable_files": "所有提交文件均缺少 blob URL，或未通过安全检查。",
  "submission_too_large": "提交内容过大。",
  "symptom_not_found": "未找到所请求的症状项。",
  "template_file_too_large": "模板文件过大。",
  "template_missing": "需要提供模板。",
  "template_no_text": "“{{path}}” 可以打开，但未能从中读取到任何文字。请上传包含书面要求的模板。",
  "template_too_large": "模板文本过长。",
  "too_many_files": "文件数量过多（最多 {{max}} 个，已接收 {{actual}} 个）。",
  "unsafe_file_name": "无法使用文件名“{{filename}}”。请重命名该文件后重试。",
  "unsupported_aggregation_aggressiveness": "不支持的 aggregation_aggressiveness「{{received}}」。允许值：{{allowed}}。",
  "unsupported_format": "不支持的文件格式。",
  "unsupported_output_language": "不支持的输出语言「{{received}}」。请从以下选项中选择：{{allowed}}。",
  "unsupported_plan_gen_format": "此处不支持「{{filename}}」的格式。请上传 Word（.docx）、PDF、Markdown（.md、.markdown）或文本（.txt）文件。",
  "unsupported_service_type": "“{{received}}”不是可用的服务。请从以下选项中选择：{{allowed}}。",
  "unsupported_strictness_level": "不支持的 strictness_level「{{received}}」。允许值：{{allowed}}。",
  "unsupported_template": "无法将“{{path}}”作为模板读取。请以 Word（.docx）、PDF、Markdown（.md、.markdown）或纯文本（.txt、.rst）格式上传。",
  "unsupported_tool": "请求的工具不受支持。",
  "upload_gate_unavailable": "源数据上传暂时不可用。请稍后重试。",
  "upload_not_allowed": "在工作区的当前阶段无法上传源数据。",
  "upload_not_allowed_before_plan": "计划获批后即可上传源数据。",
  "upload_not_allowed_generating": "报告生成期间，源数据上传已暂停。",
  "upload_not_allowed_finalizing": "工作区正在完成报告，暂时无法上传源数据。",
  "upload_not_allowed_complete": "报告已完成，无法再上传源数据。",
  "upload_not_allowed_complete_removal": "此报告已完成，其源文件无法再更改。",
  "upload_not_allowed_archived": "该工作区已归档，无法再上传源数据。",
  "upload_not_allowed_model_archived": "该工作区所属的模型已归档，无法再上传源数据。",
  "upload_size_mismatch": "上传文件的大小与预期不符，因此未被接受。请重新上传。",
  "upload_too_large": "“{{filename}}”超过了单个文件 {{limit_mb}} MB 的限制。",
  "user_intent_required": "需要提供 user_intent。",
  "version_cap_exceeded": "版本数已达上限 {{cap}}。",
  "version_create_conflict": "由于并发冲突，新版本创建失败。",
  "version_not_found": "未找到版本。",
  "version_not_succeeded": "只有已成功的版本才可导出到工作区。",
  "version_not_terminal": "该版本尚未达到终态。下载将在其成功、失败或取消后可用。",
  "version_number_required": "需要提供 version_number。",
  "webhook_url_invalid": "Webhook URL 必须是绝对的 https:// 链接。",
  "workflow_state_read_failed": "工作流状态读取失败。",
  "workspace_facts_not_found": "未找到工作区事实数据。",
  "workspace_fetch_failed": "工作区加载失败。",
  "constraint_set_invalid": "无法读取此项目的报告设置，因此未生成报告。请联系支持人员。",
  "workspace_id_and_symptom_id_required": "workspace_id 和 symptom_id 均为必填项。",
  "workspace_id_malformed": "未能正确识别本次运行所属的工作区，运行未启动。请重新打开该工作区后再次发起运行。",
  "workspace_id_required": "workspace_id 为必填项。",
  "workspace_not_found": "未找到工作区。",
  "workspace_reingest_required": "该工作区的数据接入此前已失败，重试单个文件无法恢复。请重新开始整个工作区的数据接入。",
  "workspace_archived": "该工作区已归档，为只读状态。归档是永久性的——请创建新的工作区以继续此项工作。",
  "workspace_status_invalid": "无法识别该工作区状态。工作区只能为活动或已归档。",
  "workspace_terminal": "工作区已完成且为只读状态。可使用 Concierge 进行只读问答；手动编辑和重新生成已被禁用。",
  "workspace_model_archived": "该工作区所属的模型已归档，因此工作区为只读状态。请联系模型所有者恢复该模型，或在其他模型下重新开始。",
  "current_files_missing": "请先上传至少一个模型脚本，再生成工作簿。",
  "file_empty": "“{{path}}” 为空，没有可检查的内容。请将其移除，仅上传有内容的文件。",
  "unsupported_binary": "“{{path}}” 无法按文本读取，因此无法逐行审阅。请将其移除，仅上传模型脚本。",
  "unsupported_report": "无法读取“{{path}}”。请以 Markdown（.md）、Word（.docx）或 PDF 格式上传验证报告。",
  "duplicate_path": "“{{path}}” 重复上传。每个文件在同一上传位中只能出现一次。",
  "profile_invalid": "该工作簿版式不可用。请选择其他版式，或保留默认值。",
  "pairing_parse_failed": "无法读取比对映射信息。请刷新页面并重新设置。",
  "pairing_unknown_file": "比对映射引用了未上传的文件。请刷新页面并重新设置。",
  "model_id_invalid": "该模型 ID 格式无效。请重新选择模型。",
  "model_not_found": "该模型尚未注册。请选择其他模型。",
  "model_archived": "该模型已归档，无法在其下创建新的工作区。请选择其他模型。",
  "admin_required": "此操作需要管理员权限。",
  "applied_pairs_not_in_vocab": "所选的一个或多个主题组合在「{{scope_path}}」下不可用。请从列出的选项中选择。",
  "applied_pairs_vocab_unavailable": "无法加载「{{scope_path}}」的可用主题组合。请稍后重试。",
  "applied_to_not_in_vocab": "所选的一个或多个主题在「{{scope_path}}」下不可用。请从列出的选项中选择。",
  "applied_to_vocab_unavailable": "无法加载「{{scope_path}}」的可用主题。请稍后重试。",
  "audit_unavailable": "由于无法记录本次请求，暂时无法完成。请稍后重试。",
  "blob_forbidden": "您无权访问该文件。",
  "blob_path_invalid": "该文件位置无效。",
  "confirmation_required": "此操作在执行前需要确认。请完全按照所示输入“{{expected}}”以继续。尚未删除任何内容。",
  "csrf_origin_invalid": "该请求来自无法识别的页面。请重新加载 Bennie 后重试。",
  "cursor_invalid": "此结果页已失效。请从第一页重新开始。",
  "dry_run_required": "该请求必须指明是否为试运行。",
  "empty_patch": "未提供任何更改。可编辑字段：{{mutable}}。",
  "empty_survivor_set": "未找到需要保留的工作区，因此未执行任何清理。",
  "file_name_invalid": "该文件名无效。",
  "file_name_required": "需要提供文件名。",
  "file_required": "请选择要上传的文件。",
  "gd_available_required": "请指明本模型是否适用精选知识。",
  "invalid_body": "无法读取该请求。请重试。",
  "invalid_dataset_id": "该数据集标识无效。",
  "invalid_case_id": "该案例标识无效。",
  "invalid_job_id": "该任务标识无效。",
  "invalid_model_id": "该模型 ID 无效。",
  "invalid_llm_io_ref": "该引用无效。长度不能超过 {{max_length}} 个字符。",
  "invalid_request": "无法读取该请求。请重新登录。",
  "invalid_workspace_id": "该工作区标识无效。",
  "issue_log_not_produced": "问题日志尚未生成，因此无法开始自检。请等待问题日志完成。",
  "limit_invalid": "每页数量必须介于 1 和 {{max}} 之间。",
  "limit_out_of_range": "每页数量不得超过 {{max}} 行。",
  "mdr_approve_conflict": "该模型的另一个版本已先获批准。请刷新后重试。",
  "mdr_artifact_not_uploaded": "文档文件尚未上传完成。",
  "mdr_version_already_uploaded": "该文档版本已上传。",
  "mdr_version_already_approved": "该文档版本已获批准。",
  "mdr_version_conflict": "该文档版本自您打开后已被更改。请刷新后重试。",
  "mdr_version_id_invalid": "该文档版本标识无效。",
  "mdr_reservation_consumed": "该模型已完成注册。请刷新模型列表以打开它。",
  "mdr_reservation_expired": "本次注册已超时。请重新开始注册，并再次上传文档文件。",
  "mdr_reservation_forbidden": "本次注册由他人发起，您无法继续完成。请另行开始您自己的注册。",
  "mdr_reservation_not_issued": "无法将本次注册与任何进行中的注册匹配。请重新开始注册。",
  "mdr_reservation_not_registered": "请先注册该模型——文档文件已上传，注册完成后会自动关联。",
  "mdr_version_not_found": "未找到该文档版本。",
  "mdr_version_not_parseable": "状态为「{{status}}」的文档版本无法读取。",
  "mdr_version_not_promotable": "状态为「{{status}}」的文档版本无法获批。",
  "mdr_version_not_withdrawable": "状态为「{{status}}」的文档版本无法撤回。",
  "mdr_version_already_withdrawn": "该文档版本已撤回，且撤回无法撤销。",
  "withdraw_reason_required": "撤回文档版本需要填写原因。",
  "measurement_request_incomplete": "该请求缺少所需的标识信息。",
  "model_type_unresolvable": "请提供模型类型——无法从「{{scope_path}}」推导得出。",
  "model_type_not_offered": "「{{model_type}}」不是该模型所属业务线提供的类型。请从列表中选择，或告知管理员您需要的类型尚未提供。",
  "model_type_vocab_menu_unavailable": "类型列表暂时不可用，无法确认模型类型，本次未保存。请稍后重试。",
  "menu_visibility_unavailable": "暂时无法确认服务菜单，因此未创建任何内容。请稍后重试。",
  "model_version_conflict": "该模型自您打开后已被更改。请刷新后重试。",
  "model_write_forbidden": "您无权修改该模型。",
  "workspace_write_forbidden": "您无权修改该项目。您仍可以打开并查看该项目。",
  "workspace_write_forbidden_because": "{{reason}}您仍可以打开并查看该项目。",
  "workspace_create_forbidden": "您无法在该模型下新建项目。请先联系该模型的所有者或管理员，为您开通该模型的权限。",
  "workspace_create_forbidden_because": "{{reason}}在此之前，您无法在该模型下新建项目。",
  "toolbox_model_access_forbidden": "您无法在该模型上更改此内容。请联系该模型的所有者或管理员，为您开通所需的权限。",
  "toolbox_model_access_forbidden_because": "{{reason}}在此之前，您无法在该模型上更改此内容。",
  "toolbox_job_delete_forbidden": "只有创建此作业的人、该模型的所有者或管理员才能删除它。",
  "toolbox_job_not_model_scoped": "该运行未关联任何模型，因此无法打开。请从您需要的模型下重新发起运行。",
  "unknown_fact_key": "该规范字段不在本注册表中。请刷新页面后重试。",
  "fact_value_required": "请先为该字段填写值再保存。",
  "llm_io_ref_blank": "该报告读取结果已失效。请重新读取报告后再保存这些值。",
  "model_fact_already_exists": "该规范字段已有值。请刷新后改为编辑。",
  "model_fact_not_found": "该规范字段尚未填写。请刷新后改为新增。",
  "model_fact_version_conflict": "该模型的规范内容自您打开后已被更改。请刷新后重试。",
  "model_fact_value_not_permitted": "「{{received}}」不在该字段的允许值范围内。请从以下选项中选择：{{permitted}}。",
  "model_fact_value_retired": "「{{received}}」已不再作为该字段的选项。现有条目仍可保留该值，但新条目需从以下选项中选择：{{permitted}}。",
  "model_vocabulary_unavailable": "无法加载该字段的允许值，本次修改未保存。请重试；若问题持续，请联系支持人员。",
  "model_access_already_exists": "该人员已在此模型中。请刷新后改为编辑其权限。",
  "model_access_not_found": "该人员已无此模型的权限。请刷新查看当前的权限列表。",
  "model_access_owner_not_editable": "此为模型所有者。所有者的权限只能通过转移所有权来更改。",
  "model_access_version_conflict": "该模型的权限自您打开后已被更改。请刷新后重试。",
  "model_access_transfer_conflict": "他人已先行转移该模型。请刷新查看当前所有者。",
  "model_access_owner_missing": "该模型没有登记的所有者，因此无法转移所有权。请联系管理员。",
  "service_types_required": "请选择该人员可以更改的内容；也可以不选任何内容直接添加。",
  "multipart_form_required": "此上传必须以文件上传的方式提交。",
  "name_required": "需要提供名称。",
  "not_resumable": "该工作区当前阶段无法恢复。",
  "oid_required": "需要提供目录对象 ID。",
  "plan_id_invalid": "该计划标识无效。",
  "principal_oid_unresolved": "只有已登录的组织账户才能修改模型。",
  "product_category_scope_mismatch": "产品类别与所选范围不匹配。",
  "rate_limited": "请求过于频繁。请稍候片刻后重试。",
  "reggie_foreign_blob_container": "某个运行产物指向了允许存储位置之外，因此导出已被拒绝。",
  "request_body_required": "该请求未提供任何内容。",
  "request_body_too_large": "该请求过大。",
  "row_version_required": "此更改需要记录的当前版本。请刷新后重试。",
  "scope_path_invalid": "「{{scope_path}}」不是有效的范围。",
  "search_not_configured": "当前环境未配置搜索服务，因此无法执行清理。",
  "search_query_invalid": "该搜索内容包含无法查询的字符。请仅输入姓名或电子邮件地址。",
  "search_query_too_short": "请至少输入 {{min}} 个字符以搜索人员。",
  "section_not_found_in_plan": "在计划中未找到该章节。",
  "service_type_id_invalid": "知识目录中的某个服务类型无效，因此无法显示覆盖统计。",
  "service_type_manifest_empty": "知识目录中未列出任何服务类型，因此无法显示覆盖统计。",
  "skip_aggregation_not_applicable": "仅当工作区停留在问题日志阶段时，才能跳过此步骤。",
  "source_file_name_invalid": "该源文件名无效。",
  "status_invalid": "状态「{{received}}」无效。允许的取值：{{allowed}}。",
  "subject_id_not_object_id": "请输入该 {{subject_type}} 的目录对象 ID（GUID），而非电子邮件地址。",
  "subject_id_required": "需要提供主体 ID。",
  "tags_on_ck_denied_model": "当本模型不适用精选知识时，主题和产品类别必须为空。",
  "tags_on_generic_workspace": "通用工作区的主题和产品类别必须为空。",
  "tags_without_scope_path": "主题和产品类别需要先指定范围。",
  "time_range_invalid": "时间范围无效。请检查开始和结束日期。",
  "toolbox_always_available": "工具箱始终可用，无需授权。",
  "service_type_always_entitled": "该服务类型始终可用。请在“访问”标签页中按模型授予。",
  "unknown_include_field": "「{{field}}」不是可包含的字段。",
  "unsupported_subject_type": "不支持的主体类型「{{received}}」。允许的取值：{{allowed}}。",
  "validation_failed": "无法校验该章节版本。",
  "version_section_mismatch": "该版本不属于所选章节。",
  "workspace_id_invalid": "该工作区标识无效。",
  "model_id_required": "必须指定模型。项目在已注册的模型下创建——请打开该模型，并从其“项目”标签页开始创建项目。",
  "scope_from_model": "项目的范围来自其模型，无法在此设置。请刷新页面后重试。",
  "mdr_parse_failed": "无法读取模型开发报告。请检查文件后重试。",
  "mdr_parse_contract_violation": "已读取模型开发报告，但结果无法使用。请重试，或改用其他格式上传该报告。",
  "mdr_parse_misconfigured": "此处的模型开发报告读取功能尚未正确配置。重试无法解决，请联系管理员。",
  "source_workspace_id_invalid": "未能正确识别该发现所属的项目，因此未将其添加到问题日志。请刷新页面后重试。",
  "finding_uid_invalid": "无法识别该发现，因此未将其添加到问题日志。请重新加载该项目后重试。",
  "workspace_not_under_model": "该发现并非来自该模型下的项目，因此无法添加到其问题日志。请从该模型自身的项目中打开该发现。",
  "finding_not_found": "该发现已不在其所属项目的记录中，因此无法添加到问题日志。请刷新该项目后重试。",
  "report_overarching_not_done": "该报告级问题尚在准备中，无法添加到问题日志。请在报告版本完成后重试。",
  "report_version_failed_not_escalable": "该报告级问题来自一个未能完成的报告版本，无法添加到问题日志。请生成报告的新版本。",
  "export_issue_references_invalid": "此报告的问题日志包含无法解析的引用，因此无法导出文档。请生成报告的新版本后重试。",
  "issue_uid_invalid": "无法识别该问题，因此未做任何更改。请重新加载问题日志后重试。",
  "status_reason_required": "更改问题状态需要填写原因。请填写后再次保存。",
  "assignee_invalid": "无法识别该人员，因此未更改负责人。请从可分配该模型的人员名单中选择。",
  "no_change_requested": "未请求任何更改。请先设置状态或负责人，然后再保存。",
  "issue_not_found": "该问题已不在此模型的问题日志中。请刷新查看当前列表。",
  "row_version_conflict": "该问题自您打开后已被更改，因此您的修改未能保存。请刷新后重试。",
  "export_reference_required": "无法确定要使用哪份报告。请重新导出报告后重试。",
  "export_record_not_found": "该报告已不在此项目的记录中。请重新导出后重试。",
  "export_model_mismatch": "该报告属于另一个模型下的项目，因此无法添加到此处。",
  "workspace_not_model_rooted": "此项目未关联到任何模型，因此其报告无法用作模型的开发报告。",
  "export_artifact_unreadable": "无法从存储中获取已导出的文件。请重新导出报告后重试。",
  "edit_citation_set_changed": "您的修改改动了本节的来源引用。请将编号引用恢复原样，然后重新保存。",
  "edit_issue_token_changed": "您的修改改动了本节中指向登记条目的链接。请将该链接恢复原样，然后重新保存。",
  "edit_admonition_changed": "您的修改改动了本节中的提示框。请将提示框的首行恢复原样，然后重新保存。",
  "edit_media_ref_changed": "您的修改改动了本节中的图片或嵌入内容。请将其恢复原样，然后重新保存。图注仍可编辑。",
  "edit_finding_block_changed": "您的修改改动了本节中某条发现的标题。请恢复发现编号及其周围的标点，然后重新保存。标题文字仍可改写。",
  "plan_edit_no_fields": "未提交任何修改。请至少修改一个字段，然后重新保存。",
  "plan_edit_structural_change": "您的修改改变了大纲的结构，而不仅仅是文字表述。请恢复各条目及其顺序，然后重新保存。",
  "plan_edit_ids_renumbered": "保存此修改会使大纲条目重新编号，而报告的其他部分引用了这些编号。请恢复原有编号，然后重新保存。",
  "plan_edit_enrichment_emptied": "您的修改清空了一个原本有内容的字段。请填回原有文字，或保持该字段不变，然后重新保存。",
  "plan_edit_title_template_locked": "本大纲使用了模板，因此无法在此修改其标题。请修改其他字段后重新保存。",
  "plan_edit_base_version_required": "此修改未说明其基于大纲的哪一版本，因此未保存。请重新加载大纲并再次修改。",
  "plan_edit_plan_unreadable": "无法读取此大纲，修改未保存。请重新加载页面；若再次出现，请联系支持人员。",
  "plan_edit_plan_approved": "此大纲已获批准，其条目不能再修改。",
  "plan_not_approved": "请先批准大纲。",
  "plan_item_not_found": "该大纲条目已不存在。请重新加载大纲以查看其当前内容。",
  "register_empty": "此大纲没有任何条目，因此无法批准。请至少添加一个条目，然后再批准。",
  "version_conflict": "在您编辑期间，另一位用户修改了此内容。请重新加载以查看对方的版本，然后再次修改。",
  "report_version_id_invalid": "该报告版本标识无效。请重新加载页面后重试。",
  "report_version_not_found": "该报告版本已不存在。请重新加载页面以查看当前版本。",
  "run_id_invalid": "该分析标识无效。请重新加载页面后重试。",
  "run_not_found": "该分析已不存在。请重新加载页面以查看当前分析。",
  "edit_figure_ref_changed": "您的修改改动了本节中对图或表的引用。请将引用恢复原样，然后重新保存。",
  "run_in_progress": "分析正在进行时无法添加或删除文件。分析完成后即可调整文件并重新运行。",
  "report_in_progress": "报告生成期间无法添加或删除文件。生成完成后即可调整。",
  "audit_gate_unavailable": "无法确认当前是否有分析正在运行。请稍后重试。",
  "run_scope_empty": "此项分析尚无可用文档。请先上传需要分析的文档，然后再运行。",
  "evidence_not_ingested": "此项分析的部分文件尚未摄取。请对已上传的文件点击「摄取数据」，然后重试。",
  "evidence_ingest_failed": "“{{file_name}}”无法摄取。请删除或重新上传该文件，点击「摄取数据」，然后重试。",
  "evidence_deletion_incomplete": "“{{file_name}}”未能完全删除。请再次尝试删除该文件，然后重试。",
  "phase_invalid": "无法识别该分析类型。",
  "audit_run_not_editable": "已完成分析的结果无法修改。如需更新结果，请重新运行该分析。",
  "audit_phase_required": "请在「设计有效性」标签页或「运行有效性」标签页中添加此文件，以便相应的分析能够读取它。",
  "audit_phase_invalid": "本工作区不运行「{{audit_phase}}」这类分析。请在「设计有效性」标签页或「运行有效性」标签页中添加该文件。",
  "audit_phase_not_supported": "本工作区不包含设计有效性与运行有效性分析，因此无法将文件添加到其中。",
  "audit_phase_checklist_not_approved": "请先批准「{{phase}}」检查清单。",
  "audit_phase_checklist_not_approved_unnamed": "请先批准此阶段的检查清单。",
  "completeness_plan_scope_mismatch": "工作区计划与该分析的检查清单不一致——请重新打开此分析标签页后重试。",
  "evidence_id_invalid": "该附件引用无效。",
  "evidence_not_found": "该附件已不存在。",
  "evidence_already_exists": "该附件已保存。",
  "evidence_already_withdrawn": "该附件已撤回。",
  "evidence_artifact_not_uploaded": "文件未上传完成。请重新添加。",
  "evidence_upload_failed": "无法上传该文件。",
  "evidence_upload_transport_failed": "无法上传该文件。请检查网络连接后重试。",
  "report_runs_incomplete": "生成报告需要一次已完成的设计有效性分析和一次已完成的运行有效性分析。请先运行缺少的那一项，然后再生成报告。",
  "report_version_in_progress": "已有报告版本正在生成中。请等待其完成后再试。",
  "report_generation_unfinished": "上一次报告生成未完成。请在每个未完成的章节上使用「反馈」或「从头重试」；所有章节完成后即可再次生成。",
  "latest_report_version_failed": "最新的报告版本未能生成。请先生成新版本，再下载报告或将其标记为完成。",
  "report_version_failed_regen_refused": "此报告版本未能完成，因此无法重新生成其中的章节。请生成新版本。",
  "section_is_run_result": "此项目是已完成分析的结果，无法单独更改。请重新运行分析以更新它。",
  "plan_already_approved": "此大纲已获批准。",
  "plan_approve_version_required": "请重新加载大纲，然后再次批准。",
  "plan_kind_invalid": "找不到此大纲。请重新加载页面后重试。",
  "plan_kind_mismatch": "此更改与您正在编辑的大纲不符。请重新加载页面后重试。",
  "plan_kind_not_report": "此操作只能在报告大纲上进行。请打开报告大纲后重试。",
  "plan_kind_required": "无法保存此更改。请重新加载页面后重试。",
  "plan_locked": "此大纲已获批准，不能再更改。",
  "plan_not_approvable": "此大纲需在生成完成后才能批准。请等待生成完成，或重新生成。",
  "plan_version_stale": "自您打开此大纲后，它已发生变化。请重新加载查看最新版本，然后再批准。",
  "plan_not_current": "此大纲已有更新的版本。请重新加载查看当前大纲，然后再批准。",
  "report_plan_not_current": "自本页面加载以来，报告大纲已更新。请重新加载页面，然后生成报告。",
  "plan_not_approvable_state": "此大纲目前无法批准。请重新加载页面查看大纲的当前状态。",
  "plan_approve_state_inconsistent": "大纲已获批准，但项目未能更新。请重新加载页面；如果问题仍然存在，请联系支持人员。",
  "checklist_phase_invalid": "请选择设计或运行检查清单，然后重试。",
  "checklist_not_available": "检查清单仅适用于审计项目。",
  "checklist_generation_in_progress": "此检查清单正在生成中。请等待其完成。",
  "checklist_generation_failed": "无法生成检查清单，未保存任何内容。请重试。",
  "checklist_generation_stopped": "检查清单生成已停止，未保存任何内容。准备好后请重新生成。",
  "checklist_generation_interrupted": "检查清单生成在完成前被中断，未保存任何内容。请重试。",
  "checklist_items_invalid": "无法将此更改应用到检查清单。请检查各项后重试。",
  "checklist_persist_failed": "无法保存检查清单。请重试。",
  "plan_kind_not_checklist": "此操作只能在检查清单上进行。请打开检查清单后重试。",
  "section_is_checklist_item": "这是检查清单项目。请改为在其检查清单中更改。",
  "checklist_ck_unavailable": "无法获取此检查清单所需的知识，未保存任何内容。请重试。",
  "checklist_parent_not_approved": "请先批准此检查清单所依据的计划：设计检查清单依据报告大纲，运行检查清单依据设计检查清单。",
  "checklist_already_exists": "此检查清单已生成。请打开它进行查看或编辑。",
  "checklist_task_description_missing": "请先上传任务说明或范围文件，然后再生成检查清单。",
  "audit_scope_extract_failed": "有一份范围文件无法读取。请重新上传后重试。",
  "workspace_deleting": "该工作区正在删除中，因此无法再修改。",
  "audit_run_not_completed": "此次分析完成后即可导出。",
  "audit_export_sources_unresolved": "这些结果中引用的某个来源无法与分析的来源列表匹配，因此无法导出。请重新运行分析；如果问题持续出现，请联系支持人员。",
  "issue_log_export_scope_removed": "请刷新页面以获取最新版本的 Bennie，然后重新导出。",
  "audit_run_export_unavailable": "此次分析的保存记录不完整，因此无法导出。如需其结果，请联系支持人员。",
  "speech_disabled": "语音输入暂不可用。",
  "speech_rate_limited": "语音消息过多。请稍等片刻后重试。",
  "speech_audio_invalid": "无法读取录音。请重新录制您的消息。",
  "speech_no_speech": "未检测到语音。请重试。",
  "speech_upstream_failed": "无法转写您的语音。请重试。",
  "speech_upstream_timeout": "转写超时。请重试。",
  "speech_unsupported": "此浏览器不支持语音输入。",
  "speech_mic_denied": "麦克风访问被拒绝。请在浏览器设置中允许访问后重试。",
  "speech_mic_unavailable": "未找到麦克风。请连接麦克风后重试。",
  "speech_mic_busy": "无法打开麦克风。请检查其他应用是否正在使用它。",
  "speech_cancelled": "语音输入已取消。",
  "speech_composer_disabled": "聊天正忙，语音输入已停止。您的草稿未更改。",
  "speech_request_timeout": "转写超时。请重试。",
  "speech_request_failed": "语音输入失败。请重试。",
  "speech_send_failed": "无法发送您的语音消息。请重试。",
  "audit_run_evidence_unchanged": "本阶段使用的证据与上次已完成的分析相同。请添加或移除证据后再运行。",
  "report_runs_unchanged": "这些已完成的分析已用于当前报告。请先完成新的分析，再生成另一个版本。",
  "audit_run_context_inconsistent": "无法验证分析历史记录。请刷新后重试；如果问题仍然存在，请联系支持人员。",
  "completeness_assessment_in_progress": "正在检查证据覆盖情况。请等待结果。",
  "completeness_assessment_failed": "覆盖检查失败。请重新检查以重试。",
  "completeness_read_failed": "无法加载覆盖检查。请重试。",
  "completeness_assessment_cancelled": "数据检查已取消。准备好后，请重新运行。",
  "model_set_unknown": "该模型集不可用。请从列表中选择一个。",
  "model_set_unusable": "该模型集目前不可用。请选择其他模型集。",
  "model_set_change_failed": "无法更改模型集。请重试。",
  "export_report_not_available": "尚无可编号问题的报告。",
  "export_plan_not_available": "尚无可编号问题的计划。",
  "issue_ordinals_failed": "无法加载此预览的问题编号。请刷新后重试。",
  "issue_ordinals_plan_unavailable": "无法读取报告计划，因此无法加载此预览的问题编号。请稍后重试。",
  "no_ingestable_evidence": "上传的文件均无法读取（其中 {{rejected_file_count}} 个格式不受支持），因此没有可作为报告依据的内容。请将数据以 CSV 或 JSON 导出文件的形式上传，点击「摄取数据」，然后重新生成报告。",
  "section_gen_unavailable": "无法开始生成报告。请稍后重试。",
  "tos_acceptance_required": "请先接受当前的服务条款后再继续。",
  "tos_version_mismatch": "此页面打开期间服务条款已更新。请刷新页面以查看最新版本。",
  "tos_agreement_required": "您需要同意服务条款才能继续。",
  "tos_status_unavailable": "暂时无法确认您是否已接受服务条款。请稍后重试。",
  "tos_subject_required": "服务条款的接受仅适用于已登录的用户。"
}
